// extracted by mini-css-extract-plugin
export default {"deliveriesActions":"_2m9QphBs9qKfMcGnwk8Ome"};